import React, { useState } from 'react';
import { Button, Snackbar, Alert } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { signInWithGoogle } from '../services/auth';

interface LoginButtonProps {
  onSuccess?: () => void;
}

export const LoginButton: React.FC<LoginButtonProps> = ({ onSuccess }) => {
  const [error, setError] = useState<string | null>(null);

  const handleGoogleSignIn = async () => {
    try {
      setError(null);
      await signInWithGoogle();
      onSuccess?.();
    } catch (error) {
      console.error('Failed to sign in with Google:', error);
      if (error instanceof Error) {
        setError(error.message);
      } else {
        setError('An unexpected error occurred during sign in');
      }
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleGoogleSignIn}
        startIcon={<GoogleIcon />}
        sx={{
          backgroundColor: '#fff',
          color: '#757575',
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
          textTransform: 'none',
          boxShadow: '0 2px 4px 0 rgba(0,0,0,0.25)',
          padding: '10px 20px',
        }}
      >
        Sign in with Google
      </Button>
      <Snackbar 
        open={!!error} 
        autoHideDuration={6000} 
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
    </>
  );
}; 